import {useTitle} from "@/Utilities/Hooks";
import AppLayout from "@/Layouts/AppLayout";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import {Inertia} from "@inertiajs/inertia";
import React from "react";
import {UserSettings} from "@/Pages/Organization/UserSettings";
import LayoutIcon from "@/Components/LayoutIcon";
import {Users as UsersIcon} from "@/Icons";

export default function Edit({
                                 user,
                                 roles,
                                 errors,
                                 flash,
                                 auth
}) {
    useTitle('Handle user edit');

    // Map static roles to an array with { label, value } objects
    let roles_options = Object.keys(roles).reduce((p, c) => {
        return [...p, { label: roles[c], value: c }];
    }, []);

    return (
        <>
            <div className="my-3">
                <UserSettings user={user.data} roles_options={roles_options} errors={errors} auth={auth}/>
            </div>
        </>
    )
}

Edit.layout = page => (
    <AppLayout title="Edit user">
        <OrganizationLayout
            header="Edit"
            backAction={{ label: 'Back', callback: () => Inertia.visit('/users') }}
            preamble={ page.props.user && page.props.user.data ? `${page.props.user.data.fullname}` : null }
            icon={<LayoutIcon><UsersIcon size={40} className="text-black"/></LayoutIcon>}
        >
            {page}
        </OrganizationLayout>
    </AppLayout>
)